import { Paper } from "@material-ui/core";
import List from "@material-ui/core/List";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton from "react-loading-skeleton";
import { Company } from "../../graphql/baseTypes";
import { LoadingIndicator } from "../Loading";
import CompanyListItem from "./CompanyListItem";
interface Props {
  items: Array<Company>;
  loading?: boolean;
  loadMore?: () => any;
  hasMore?: boolean;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: 20,
      width: "100%",
      padding: "20px 10px",
    },
  })
);
const CompanyList: React.FC<Props> = ({
  items,
  loading,
  hasMore = false,
  loadMore = () => {},
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <List component="ul" aria-label="primary-company-list">
        {items.length === 0 && !loading && <h5>Keine Auftraggeber gefunden</h5>}
        {loading && <Skeleton count={5} height={50} />}
        {!loading && (
          <InfiniteScroll
            dataLength={items.length} //This is important field to render the next data
            loader={<LoadingIndicator />}
            next={loadMore}
            hasMore={hasMore}
          >
            {items.map((item, index) => (
              <CompanyListItem
                key={index}
                item={item}
                isLast={index === items.length - 1}
              />
            ))}
          </InfiniteScroll>
        )}
      </List>
    </Paper>
  );
};

export default CompanyList;
